import { MDSChipInputItem } from "@/mds";
import { SyncScopeRoleKind } from "@/domains/sync-scopes/types";

export enum ShareSheetEntityKind {
  Note = "note",
  Template = "template",
  Collection = "collection",
}

export enum ShareSheetChipType {
  Email = "email",
  SpaceAccount = "space_account",
  Collection = "collection",
}

export type ShareChip = MDSChipInputItem & {
  id: string;
  type: ShareSheetChipType;
  displayName: string;
  secondaryLabel?: string;
  photoUrl?: string;
  role?: SyncScopeRoleKind;
};
